import React from 'react'
import StandardProductDashboard from './StandardProductDashboard'

/**
 * Sports — Sky's sports dashboard.
 *
 * The lowest-volume department by far: roughly one comment every two days. On a dashboard built around distribution, n=40 is noise - which is exactly why the design refuses to pre-judge what Sports should see until Sports has spoken.
 *
 * It is deliberately three lines. A department's dashboard is an ARRANGEMENT,
 * and today every department arranges the same way, so this file's only job is
 * to name the product and its copy. When Sports asks for something different,
 * this is the file that changes: drop StandardProductDashboard, compose the kit
 * primitives directly, and nothing else in the codebase moves.
 */
export const SportsDashboard: React.FC = () => (
  <StandardProductDashboard
    product="sports"
    title="Sports"
    subtitle="Sky Sports brand activity."
  />
)

export default SportsDashboard
